import { supportsPassiveEvents } from 'detect-passive-events';

/**
 * Get meta value from document.
 * @param {string} name
 * @returns {string|null}
 */
export function getMeta(name) {
  const meta = document.head.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    return null;
  }

  return meta.content;
}

/**
 * Add passive event listener to browser if supported.
 * @param {Window|HTMLElement} element
 * @param {String} event
 * @param {EventListener|Function} listener
 * @param {Boolean} passive
 */
export function addEventListener(element, event, listener, passive = true) {
  if (supportsPassiveEvents) {
    element.addEventListener(event, listener, { capture: false, passive });
  } else {
    element.addEventListener(event, listener, false);
  }
}

/**
 * Add passive event listener to browser if supported.
 * @param {Window|HTMLElement} element
 * @param {String} event
 * @param {EventListener|Function|Boolean} listener
 */
export function removeEventListener(element, event, listener) {
  element.removeEventListener(event, listener);
}

/**
 * Request animation frame.
 * @param {Function} fn
 */
export function requestAnimationFrame(fn) {
  // noinspection OverlyComplexBooleanExpressionJS
  const raf = window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function () {
      window.setTimeout(fn, 1000 / 60);
    };

  raf(fn);
}

export function onDomReady(fn) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
